import { Pipe, PipeTransform } from '@angular/core';

import { LANGUAGES } from '@core/constants/language.constants';

@Pipe({
  name: 'languageFlagIcon',
  // eslint-disable-next-line
  standalone: false,
})
export class LanguageFlagIconPipe implements PipeTransform {
  constructor() {}

  transform(langCode?: string): string {
    if (!langCode) {
      return `flag-icon-${LANGUAGES.DE}`;
    }

    if (langCode === LANGUAGES.EN) {
      return 'flag-icon-gb';
    }

    if (langCode === LANGUAGES.UK) {
      return 'flag-icon-ua';
    }

    return `flag-icon-${langCode}`;
  }
}
